import { render, staticRenderFns } from "./LeadershipReviewManager.vue?vue&type=template&id=4ecd6376&scoped=true"
import script from "./LeadershipReviewManager.vue?vue&type=script&lang=js"
export * from "./LeadershipReviewManager.vue?vue&type=script&lang=js"
import style0 from "./LeadershipReviewManager.vue?vue&type=style&index=0&id=4ecd6376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecd6376",
  null
  
)

export default component.exports